import React, { useState, useCallback } from "react";
import StartScreen from "@/components/screens/StartScreen";
import StyleSelect from "@/components/screens/StyleSelect";
import CaptureScreen from "@/components/screens/CaptureScreen";
import ProcessingScreen from "@/components/screens/ProcessingScreen";
import ResultScreen from "@/components/screens/ResultScreen";
import { Toaster, toast } from "sonner";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL || "https://agent100.wibe.si";
const API = `${BACKEND_URL}/api`;

export default function Photobooth() {
  const [stage, setStage] = useState("start"); // start | style | capture | processing | result
  const [styleId, setStyleId] = useState(null);
  const [capturedImage, setCapturedImage] = useState(null); // data URL
  const [generated, setGenerated] = useState(null); // { id, dataUrl, shareUrl }

  const reset = useCallback(() => {
    setStage("start");
    setStyleId(null);
    setCapturedImage(null);
    setGenerated(null);
  }, []);

  const handleStart = () => setStage("style");
  const handleStyleConfirm = (id) => {
    setStyleId(id);
    setStage("capture");
  };

  const handleCaptured = async (dataUrl) => {
    setCapturedImage(dataUrl);
    setStage("processing");
    try {
      const base64 = dataUrl.split(",", 2)[1];
      const res = await axios.post(`${API}/photobooth/generate`, {
        style_id: styleId,
        image_base64: base64,
      });
      const { id, image_base64, mime_type } = res.data;
      const dataOut = `data:${mime_type};base64,${image_base64}`;
      const shareUrl = `${PUBLIC_URL}/api/photobooth/share/${id}`;
      setGenerated({ id, dataUrl: dataOut, shareUrl });
      setStage("result");
    } catch (err) {
      console.error(err);
      toast.error("Generacija ni uspela. Poskusi znova.", {
        description: err?.response?.data?.detail || err.message,
      });
      setStage("capture");
    }
  };

  return (
    <div
      className="film-grain min-h-screen overflow-hidden"
      data-testid="photobooth-root"
    >
      {stage === "start" && <StartScreen onStart={handleStart} />}
      {stage === "style" && (
        <StyleSelect
          selected={styleId}
          onSelect={setStyleId}
          onConfirm={handleStyleConfirm}
          onBack={reset}
        />
      )}
      {stage === "capture" && (
        <CaptureScreen
          onCaptured={handleCaptured}
          onBack={() => setStage("style")}
        />
      )}
      {stage === "processing" && <ProcessingScreen />}
      {stage === "result" && generated && (
        <ResultScreen
          generated={generated}
          onRetake={() => {
            setCapturedImage(null);
            setGenerated(null);
            setStage("capture");
          }}
          onFinish={reset}
        />
      )}
      {/* Offset pushes toasts toward mid-screen so they're visible at eye
          level on a portrait kiosk display */}
      <Toaster theme="dark" position="top-center" offset="30vh" />
    </div>
  );
}
